import { z } from 'zod';
export var NamedConstructionFlags = z.object({
    reportConstructionId: z.string().optional(),
    constructionName: z.string().optional().nullable(),
    takeConstruction: z.boolean().optional(),
    takeSoundInsulationCalculation: z.boolean().optional(),
    takeLaboratoryDataAnalisys: z.boolean().optional(),
});
export var BaseReportInfoFlags = z.object({
    namedConstructionFlags: z.array(NamedConstructionFlags).optional().nullable(),
    floorNumber: z.string().optional().nullable(),
    takeFloor: z.boolean().optional(),
});
export var GeneralCharacteristics = z.object({
    takeRoomCharacteristic: z.boolean().optional(),
    takeWallMaterialsVolumesCalculation: z.boolean().optional(),
    takeFloorMaterialsVolumesCalculation: z.boolean().optional(),
});
export var SoundInsulationCalculation = z.object({
    takeEnclosingStructuresSoundInsulationCalculation: z.boolean().optional(),
    baseReportInfoFlags: z.array(BaseReportInfoFlags).optional().nullable(),
});
export var ThermalInsulationCalculation = z.object({
    takeDetailedCalculatingMethod: z.boolean().optional(),
    baseReportInfoFlags: z.array(BaseReportInfoFlags).optional().nullable(),
});
export var FloorDocumentsFlags = z.object({
    takeTitleList: z.boolean().optional(),
    takeContent: z.boolean().optional(),
    takeIntroduction: z.boolean().optional(),
    generalCharacteristics: GeneralCharacteristics.optional(),
    soundInsulationCalculation: SoundInsulationCalculation.optional(),
    thermalInsulationCalculation: ThermalInsulationCalculation.optional(),
    takeConclusion: z.boolean().optional(),
    takeUsedLiteratureList: z.boolean().optional(),
    takeSupplementSoundInsulationProtocolsWithCalculation: z.boolean().optional(),
    takeSupplementThermalInsulationProtocolsWithCalculation: z.boolean().optional(),
});
export var FormReportSchema = z.object({
    reportInfoId: z.string(),
    customerName: z.string().min(1, 'Поле обязательно для заполнения'),
    projectName: z.string().min(1, 'Поле обязательно для заполнения'),
    objectDescription: z.string().min(1, 'Поле обязательно для заполнения'),
    creatorFullName: z.string().min(1, 'Поле обязательно для заполнения'),
    code: z.string().min(1, 'Поле обязательно для заполнения'),
    country: z.string().min(1, 'Поле обязательно для заполнения'),
    director: z.string().min(1, 'Поле обязательно для заполнения'),
    logo: z
        .any()
        .refine(function (file) { return file instanceof File && file.size > 0; }, 'Поле обязательно для заполнения'),
    logoValue: z.string().min(1, 'Поле обязательно для заполнения'),
    commonProjectName: z.string().min(1, 'Поле обязательно для заполнения'),
    date: z
        .string()
        .min(1, 'Поле обязательно для заполнения')
        .refine(function (value) { return !value.includes('_'); }, 'Неверный формат даты')
        .refine(function (value) {
        var _a = value.split('-').map(Number), day = _a[0], month = _a[1], year = _a[2];
        var date = new Date(year, month - 1, day);
        return (date.getFullYear() === year &&
            date.getMonth() === month - 1 &&
            date.getDate() === day);
    }, 'Дата указана некорректно'),
    //logoUrl: z.string().min(1, 'Поле обязательно для заполнения'),
    floorDocumentsFlags: FloorDocumentsFlags,
});
